import React from 'react';
import styles from './contacto.module.css';
import Swal from "sweetalert2";
import logo from '../../assets/logo-color.png';
import { useForm } from 'react-hook-form';


export default function TuComponente() {

    const { register, handleSubmit, formState: { errors }, reset } = useForm();

    const onSubmit = data => {
        fetch('https://transporteleo.com.ar/form/send_mail.php', {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json'
            },
            body: JSON.stringify(data)
        })
            .then(response => response.json())
            .then(result => {
                if (result.isOk) {
                    Swal.fire({
                        title: 'Gracias por contactarnos',
                        imageUrl: logo,
                        imageHeight: 160,
                        imageWidth: 350,
                        text: 'En breve le enviaremos el presupuesto',
                        confirmButtonColor: 'rgb(133, 15, 15)',
                    });
                    reset();
                } else {
                    Swal.fire({
                        icon: 'error',
                        title: 'Error al enviar el correo',
                        text: result.msj || 'Algo salió mal, volvé a intentarlo en unos minutos.',
                        confirmButtonColor: 'rgb(133, 15, 15)',
                    });
                }
            })
            .catch(() => {
                Swal.fire({
                    icon: 'error',
                    title: 'Sin conexión',
                    text: 'No se pudo enviar el mensaje. Verificá tu conexión e intentá nuevamente.',
                    confirmButtonColor: 'rgb(133, 15, 15)',
                });
            });
    };

    return (
        <>
            <div className={styles.fondo_contact} id='Contacto'>
                <div className={styles.fondo_blur}>

                    <form className={styles.contact_form} onSubmit={handleSubmit(onSubmit)}>
                        <div className={styles.title_contact}>
                            <span className={styles.title_1}>CONSULTE</span>
                            <span className={styles.title_2}> SU VIAJE</span>
                        </div>

                        <div className={styles.inputContainer}>
                            <label className={styles.labelContainer}>NOMBRE Y APELLIDO</label>
                            <input
                                type="text"
                                placeholder="Nombre y Apellido"
                                className={styles.inputField}
                                {...register("nombre", {
                                    required: "El nombre es obligatorio",
                                    minLength: { value: 3, message: "Mínimo 3 caracteres" }
                                })}
                            />
                            {errors.nombre && <span className={styles.errorMsg}>{errors.nombre.message}</span>}
                        </div>

                        <div className={styles.inputContainer}>
                            <label className={styles.labelContainer}>MAIL</label>
                            <input
                                type="email"
                                placeholder="email@correo.com"
                                className={styles.inputField}
                                {...register("correo", {
                                    required: "El email es obligatorio",
                                    pattern: {
                                        value: /^[^\s@]+@[^\s@]+\.[^\s@]+$/,
                                        message: "Ingresá un email válido"
                                    }
                                })}
                            />
                            {errors.correo && <span className={styles.errorMsg}>{errors.correo.message}</span>}
                        </div>

                        <div className={styles.inputContainer}>
                            <label className={styles.labelContainer}>ORIGEN</label>
                            <input
                                type="text"
                                placeholder="¿Desde dónde viajás?"
                                className={styles.inputField}
                                {...register("origen", {
                                    required: "El origen es obligatorio"
                                })}
                            />
                            {errors.origen && <span className={styles.errorMsg}>{errors.origen.message}</span>}
                        </div>

                        <div className={styles.inputContainer}>
                            <label className={styles.labelContainer}>DESTINO</label>
                            <input
                                type="text"
                                placeholder="¿Hasta dónde viajás?"
                                className={styles.inputField}
                                {...register("destino", {
                                    required: "El destino es obligatorio"
                                })}
                            />
                            {errors.destino && <span className={styles.errorMsg}>{errors.destino.message}</span>}
                        </div>

                        <div className={styles.inputContainer}>
                            <label className={styles.labelContainer}>FECHA DE SALIDA</label>
                            <input
                                type="date"
                                className={styles.inputField}
                                {...register("fechaSalida", {
                                    required: "La fecha de salida es obligatoria"
                                })}
                            />
                            {errors.fechaSalida && <span className={styles.errorMsg}>{errors.fechaSalida.message}</span>}
                        </div>

                        <div className={styles.inputContainer}>
                            <label className={styles.labelContainer}>FECHA DE REGRESO</label>
                            <input
                                type="date"
                                className={styles.inputField}
                                {...register("fechaRegreso", {})}
                            />
                        </div>

                        <div className={styles.inputContainer}>
                            <label className={styles.labelContainer}>CANTIDAD DE PERSONAS</label>
                            <input
                                type="number"
                                placeholder="¿Cuántas personas viajan?"
                                className={styles.inputField}
                                min="1"
                                {...register("cantPers", {
                                    required: "La cantidad de personas es obligatoria",
                                    min: { value: 1, message: "Debe ser al menos 1 persona" }
                                })}
                            />
                            {errors.cantPers && <span className={styles.errorMsg}>{errors.cantPers.message}</span>}
                        </div>

                        <button className={styles.button_contact} type="submit">ENVIAR</button>
                    </form>
                </div>
            </div>
        </>
    );
}
